<div class="flex flex-col items-center px-4">
  <div class="w-full max-w-2xl mt-6 lg:w-screen">
    <img class="maintenance-icon" src="assets/img/maintenance.svg" alt="Prace serwisone" />
    <h3 class="mb-6 text-xxl text-center font-bold">Prace serwisowe na platformie płatności</h3>

    <div class="mb-6 text-l text-center text-500">
      <p>
        Przepraszamy, serwis jest tymczasowo niedostępny.<br />
        Płatności będą ponownie możliwe w ciągu najbliższych kilku godzin.
      </p>
      <br class="hidden md:flex" />
      <p>Kontakt: <a class="underline" href="mailto:pomoc@billtech.pl" title="Pomoc">pomoc@billtech.pl</a></p>
    </div>
  </div>
</div>
